import { formSubscriptionItems } from '../constants';
import filterSubscription from './filterSubscription';

const shallowEqualKeys = ['touched', 'visited'];

const filterFormState = (state, prevState, subscription, force) => {
  const result = {};
  const diff =
    filterSubscription(
      result,
      state,
      prevState,
      subscription,
      formSubscriptionItems,
      shallowEqualKeys
    ) || !prevState;

  return diff || force ? result : undefined;
};

export default filterFormState;
